import { Stack, StackProps, Typography } from '@mui/material'
import { AttachMoneyOutlined, BoltOutlined, TimerOutlined } from '@mui/icons-material'
import { numericUtils } from '@/utils/numeric'

import { METRIC_MUTED_COLOR, METRIC_VALUE_COLOR } from './metricTokens'

const iconSx = { fontSize: 22, color: METRIC_MUTED_COLOR } as const

const valueSx = {
  fontSize: '0.95rem',
  fontWeight: 700,
  lineHeight: 1.2,
  color: METRIC_VALUE_COLOR,
  fontVariantNumeric: 'tabular-nums',
  letterSpacing: '-0.03em',
  textAlign: 'center',
} as const

const labelSx = {
  fontSize: '0.66rem',
  fontWeight: 600,
  lineHeight: 1.2,
  color: METRIC_MUTED_COLOR,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  textAlign: 'center',
} as const

interface ChargingSessionSummaryProps extends StackProps {
  elapsedTime?: string
  idleElapsedTime?: string
  kwhDelivered?: number | null | undefined
  totalCost?: string | null | undefined
  idleCost?: string | null | undefined
}

const ChargingSessionSummary: React.FC<ChargingSessionSummaryProps> = ({
  elapsedTime,
  idleElapsedTime,
  kwhDelivered,
  totalCost,
  idleCost,
  ...props
}) => {
  const hasIdleCostInfo = numericUtils.hasValue(idleCost)

  return (
    <Stack direction="row" alignItems="flex-start" spacing={0.5} width="100%" {...props}>
      <Stack direction="column" alignItems="center" flex={1} spacing={0.5}>
        <TimerOutlined sx={iconSx} />
        <Stack direction="column" alignItems="center" spacing={0}>
          <Typography sx={valueSx}>{elapsedTime}</Typography>
          {hasIdleCostInfo && (
            <Typography variant="caption" fontWeight="bold" textAlign="center" color="error">
              + {idleElapsedTime}
            </Typography>
          )}
        </Stack>
        <Typography sx={labelSx}>Tempo decorrido</Typography>
      </Stack>
      <Stack direction="column" alignItems="center" flex={1} spacing={0.5}>
        <BoltOutlined sx={iconSx} />
        <Typography sx={valueSx}>
          {numericUtils.formatKwh(kwhDelivered)}
          <Typography component="span" sx={{ ...valueSx, fontSize: '0.72rem', fontWeight: 500, ml: 0.4 }}>
            kWh
          </Typography>
        </Typography>
        <Typography sx={labelSx}>Energia consumida</Typography>
      </Stack>
      <Stack direction="column" alignItems="center" flex={1} spacing={0.5}>
        <AttachMoneyOutlined sx={iconSx} />
        <Stack direction="column" alignItems="center" spacing={0}>
          <Typography sx={valueSx}>{numericUtils.formatNumberToBRLCurrency(totalCost, 'N/A')}</Typography>
          {hasIdleCostInfo && (
            <Typography variant="caption" fontWeight="bold" textAlign="center" color="error">
              + {numericUtils.formatNumberToBRLCurrency(idleCost, 'N/A')}
            </Typography>
          )}
        </Stack>
        <Typography sx={labelSx}>Custo atual</Typography>
      </Stack>
    </Stack>
  )
}

export default ChargingSessionSummary
